import React from 'react';
import { IconProps } from '../types/types';

const NFLX: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="url(#paint0_linear)" d="M0 0h18v18H0z"/><path fill="#DB0916" d="M6 4h2v10H6zM10 4h2v10h-2z"/><path d="M10 14h2L8 4H6l4 10z" fill="#FF3540"/><defs><linearGradient id="paint0_linear" x1="3.349" y1="3.122" x2="21.904" y2="24.434" gradientUnits="userSpaceOnUse"><stop stopColor="#1A1E21"/><stop offset="1" stopColor="#06060A"/></linearGradient></defs></svg>
);

export default NFLX;